import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import actionCreators from 'actions/creators';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import classNames from "classnames";
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoySrefView from "components/commons/router/CupoySrefView";

class CreateAllowanceView extends Component {

    constructor(props) {
        super(props);

        this.handleSubmit = this
            .handleSubmit
            .bind(this);

        this.state = {
            allowanceNumber: '',
            yearmonth: '',
            invoicenumber: '',
            istarttag: '',
            salesamount: 0,
            newSalesamount: 0,
            buyerName: '',
            buyerCrn: '',
            allowanceDay: new Date(),
            invoiceDay: 0,
            pdtlist: [],
            invoicePdtlist: [],
            isLoading: false,
            isError: false,
            errorMsg: '',
            isParamsError: false,
            isParamsErrorMap: {},
            fromState: undefined,
            isLoadingInfo: false,
            isInfoError: false,
        }
    }

    componentDidMount() {

        var stateHistory = CupoyRouter.getHistory();
        var fromState;

        if(stateHistory.length > 1) {

            for(var i = 0; i < stateHistory.length; i++) {
                var prev = stateHistory[stateHistory.length - i],
                    statename;

                if(prev) {
                    statename = prev.state.name;

                    if(statename === CupoyRouter.STATES.INVOICE_LIST) {
                        fromState = prev;
                        break;
                    }
                }
            }
        }

        this.setState({
            fromState: fromState,
        });

        this.init(this.props);
    }

    componentWillReceiveProps(nextProps) {

        this.init(nextProps);
    }

    init(props) {

        if (!props.match) {
            return;
        }

        const {
            yearmonth,
            istarttag,
            invoicenumber,
        } = props.match.params;

        if(yearmonth === this.state.yearmonth && istarttag === this.state.istarttag && invoicenumber === this.state.invoicenumber) {
            return;
        }

        this.setState({
            yearmonth: yearmonth,
            istarttag: istarttag,
            invoicenumber: invoicenumber,
            allowanceNumber: istarttag + invoicenumber,
            isLoadingInfo: true,
            isInfoError: false,
        }, () => {
            // get invoice from redux
            const invoice = props.invoices[istarttag + invoicenumber];

            if (!invoice) {
                // 沒經過list就進來，抓取發票資料
                this.props.invoiceActions.getInvoiceInfo({
                    yearmonth: yearmonth,
                    istarttag: istarttag,
                    invoicenumber: invoicenumber,
                }).then((result) => {
                    this.setState({
                        isLoadingInfo: false,
                    });
                    this.initInvoice();
                }, (error) => {
                    this.setState({
                        isLoadingInfo: false,
                        isInfoError: true,
                    });
                });
            } else {
                this.setState({
                    isLoadingInfo: false,
                });
                this.initInvoice();
            }
        })
    }

    initInvoice() {

        const {
            istarttag,
            invoicenumber,
        } = this.state;

        const invoice = this.props.invoices[istarttag + invoicenumber];

        if(!invoice) {
            this.setState({
                isInfoError: true,
            });
            return;
        }

        const {
            detail,
            receipttime,
        } = invoice;

        const {
            pdtlist,
            salesamount,
            salestax,
            buyerinfo,
        } = detail;

        const {
            buyername: buyerName,
            buyercrn: buyerCrn,
        } = buyerinfo;

        var newPdtlist = [];

        for(var i = 0; i < pdtlist.length; i++) {
            var product = pdtlist[i];

            newPdtlist.push({
                pdtname: product.pdtname,
                pdtcount: product.pdtcount,
                pdtprice: product.pdtprice,
                pdtid: product.pdtid,
                taxType: product.taxtype,
                isAllowance: false,
                isParamsErrorMap: {},
            });
        }

        this.setState({
            salesamount: salesamount + salestax,
            newSalesamount: salesamount + salestax,
            buyerName: buyerName,
            buyerCrn: buyerCrn,
            pdtlist: newPdtlist,
            invoicePdtlist: pdtlist,
            invoiceDay: receipttime
        });
    }

    onInputChange(fieldname, event) {
        
        this.setState({
            [fieldname]: event.target.value
        })
    }

    onPdtCountInputChange(index, event) {

        var value = event.target.value;

        const oripdt = this.state.invoicePdtlist[index];
        const pdt = this.state.pdtlist[index];

        if(value > oripdt.pdtcount) {
            value = oripdt.pdtcount;
        } else if(value < 1) {
            value = 1;
        }

        const newpdt = Object.assign({}, pdt, { pdtcount: value })
        const newpdtlist = this.state.pdtlist;

        newpdtlist[index] = newpdt;

        this.setState({
            pdtlist: newpdtlist
        }, () => {
            this.updateNewSalesamount()
        });
    }

    onPdtPriceInputChange(index, event) {

        var value = event.target.value;

        const oripdt = this.state.invoicePdtlist[index];
        const pdt = this.state.pdtlist[index];

        if(value > oripdt.pdtprice) {
            value = oripdt.pdtprice;
        } else if(value < 1) {
            value = 1;
        }

        const newpdt = Object.assign({}, pdt, { pdtprice: value })
        const newpdtlist = this.state.pdtlist;

        newpdtlist[index] = newpdt;

        this.setState({
            pdtlist: newpdtlist
        }, () => {
            this.updateNewSalesamount()
        });
    }

    toggleIsAllowance(index) {

        const pdt = this.state.pdtlist[index];
        const newpdt = Object.assign({}, pdt, { isAllowance: !pdt.isAllowance })
        const newpdtlist = this.state.pdtlist;

        newpdtlist[index] = newpdt;

        this.setState({
            pdtlist: newpdtlist
        }, () => {
            this.updateNewSalesamount()
        });
    }

    updateNewSalesamount() {

        const {
            pdtlist,
            salesamount,
        } = this.state;

        var i, product, allowFaxTotal = 0;

        for(i = 0; i < pdtlist.length; i++) {
            product = pdtlist[i];

            if(product.isAllowance) {
                var allow = Math.round(product.pdtcount * product.pdtprice);
                allowFaxTotal += allow;
            }
        }

        allowFaxTotal = Math.round(allowFaxTotal * 1.05);
        
        var newSalesamount = salesamount - allowFaxTotal;

        if(newSalesamount < 0) {
            newSalesamount = 0;
        }

        this.setState({
            newSalesamount: newSalesamount
        });
    }

    handleSubmit(event) {

        event.preventDefault();

        if (this.state.isLoading) {
            return;
        }

        const {
            allowanceNumber,
            yearmonth,
            invoicenumber,
            istarttag,
            newSalesamount,
            buyerName,
            buyerCrn,
            allowanceDay,
            invoiceDay,
            pdtlist,
        } = this.state;

        if(newSalesamount < 0) {
            return;
        }

        var isParamsError = false;
        var isParamsErrorMap = {};

        const allowancedate = allowanceDay.getTime();

        if(!allowanceNumber) {
            isParamsErrorMap['allowanceNumber'] = true;
            isParamsError = true;
        }

        var pdtlistResult = [];

        for(var i = 0; i < pdtlist.length; i++) {
            var product = pdtlist[i];

            if(product.isAllowance) {

                product.isParamsErrorMap['pdtprice'] = false;

                if(product.pdtprice <= 0) {
                    product.isParamsErrorMap['pdtprice'] = true;
                    isParamsError = true;
                }

                pdtlistResult.push({
                    pdtcount: product.pdtcount,
                    pdtid: product.pdtid,
                    pdtname: product.pdtname,
                    pdtprice: product.pdtprice,
                    taxType: product.taxType,
                });
            }
        }

        if(pdtlistResult.length === 0) {
            isParamsError = true;
        }

        if(isParamsError) {

            this.setState({
                pdtlist: pdtlist,
                isParamsError: isParamsError,
                isParamsErrorMap: isParamsErrorMap,
            })

            return;
        }

        var payload = {
            buyername: buyerName,
            buyercrn: buyerCrn,
            yearmonth: yearmonth,
            istarttag: istarttag,
            invoiceNumber: invoicenumber,
            allowanceNumber: allowanceNumber,
            allowancedate: allowancedate,
            pdtlist: pdtlistResult,
            invoicedate: invoiceDay,
        };

        this.setState({
            isLoading: true,
            errorMsg: '',
            pdtlist: pdtlist,
            isParamsError: isParamsError,
            isParamsErrorMap: isParamsErrorMap,
        }, () => {
            this.props.allowanceActions.createAllowance(payload).then((result) => {

                if (result) {
                    // 重拉資料更新store
                    this.props.invoiceActions.getInvoiceInfo({
                        yearmonth: yearmonth,
                        istarttag: istarttag,
                        invoicenumber: invoicenumber,
                    }).then(() => {
                        this.props.webActions.cupoyStateGo(CupoyRouter.STATES.INVOICE_INFO, {
                            yearmonth: yearmonth,
                            istarttag: istarttag,
                            invoicenumber: invoicenumber,
                        });
                    }, () => {
                        this.props.webActions.cupoyStateGo(CupoyRouter.STATES.INVOICE_INFO, {
                            yearmonth: yearmonth,
                            istarttag: istarttag,
                            invoicenumber: invoicenumber,
                        });
                    })
                } else {
                    this.setState({
                        isLoading: false,
                        errorMsg: '發生無法處理的錯誤，請聯絡工程師',
                    });
                }
            }, (error) => {
                if (error && error.message) {
                    this.setState({
                        isLoading: false,
                        errorMsg: error.message,
                    });
                } else {
                    this.setState({
                        isLoading: false,
                        errorMsg: '發生無法處理的錯誤，請聯絡工程師',
                    });
                }
            });
        })
    }

    // ------------------------------
    // 時間變動
    // ------------------------------
    onDaySelectChange(selectedDay, modifiers) {

        this.setState({
            allowanceDay: selectedDay,
        });
    }

    // ------------------------------
    // 將 DatePicker style改為absolute
    // ------------------------------
    renderCustomDayPickerOverlay({ classNames, selectedDay, children }) {

        return (
            <div className={classNames.overlayWrapper} style={{ position: 'absolute', lineHeight: 'normal' }}>
                <div className={classNames.overlay}>
                    {children}
                </div>
            </div>
        );
    }

    render() {

        const {
            allowanceNumber,
            allowanceDay,
            salesamount,
            newSalesamount,
            pdtlist,
            invoicePdtlist,
            isParamsErrorMap,
            isLoadingInfo,
            isInfoError,
            fromState,
            yearmonth,
            istarttag,
            invoicenumber,
        } = this.state;

        const allowanceDayValue = allowanceDay ? formatDate(allowanceDay, 'YYYY/MM/DD') : '';

        return (

            <div id="create-allowance">
                <div className="header-bar mix">
                    <ul className="bread-crumbs">
                        <li className="crumb-item">
                            {fromState ?
                                <CupoySrefView
                                    statename={fromState.state.name}
                                    params={fromState.params}
                                    querys={fromState.querys}
                                >
                                    開立發票列表
                                </CupoySrefView>
                                :
                                <CupoySrefView
                                    statename={CupoyRouter.STATES.INVOICE_LIST}
                                    params={{
                                        page: 1,
                                    }}
                                >
                                    開立發票列表
                                </CupoySrefView>
                            }
                        </li>
                        <div className="crumb-arrow"><i className="zmdi zmdi-chevron-right"></i></div>
                        <li className="crumb-item">
                            <CupoySrefView
                                statename={CupoyRouter.STATES.INVOICE_INFO}
                                params={{
                                    yearmonth: yearmonth,
                                    istarttag: istarttag,
                                    invoicenumber: invoicenumber,
                                }}
                            >
                                發票「{istarttag}-{invoicenumber}」
                            </CupoySrefView>
                        </li>
                        <div className="crumb-arrow"><i className="zmdi zmdi-chevron-right"></i></div>
                        <li className="crumb-item active">
                            <a>開立折讓單</a>
                        </li>
                    </ul>
                    <div className="button-group">

                        {this.state.isError ? 
                            <span className="error">發生無法處理的錯誤，請聯絡工程師</span>
                            :
                            null
                        }
                        <a className="button blue" onClick={this.handleSubmit}>
                            {this.state.isLoading
                                ? <i className="zmdi zmdi-spinner animate-spinner"></i>
                                : null}
                            開立折讓單
                        </a>
                    </div>
                </div>

                {isLoadingInfo ?
                    <div className="form has-padding">
                        <div className="form-row">
                            <div className="form-col loading">
                                <i className="zmdi zmdi-spinner animate-spinner"></i>
                                <span>正在讀取訂單資訊</span>
                            </div>
                        </div>
                    </div>
                    :
                    null
                }

                {isInfoError ?
                    <div className="form has-padding">
                        <div className="form-row">
                            <div className="form-col loading">
                                發生錯誤，請再嘗試一次。
                            </div>
                        </div>
                    </div>
                    :
                    null
                }

                {!isLoadingInfo && !isInfoError ?
                    <div className="scroll-content">
                        <div className="form" style={{minHeight: '100%'}}>
                            <div className="block-form">
                                <h3 className="block-title">基本資訊</h3>
                                <div className="block-form-row">
                                    <label className="block-form-col">
                                        <h5 className="title">發票金額（含稅）</h5>
                                        <p className="description">
                                            原金額：{salesamount}，折讓後：{newSalesamount}
                                        </p>
                                    </label>
                                </div>
                                <div className="block-form-row">
                                    <label 
                                        className={classNames("block-form-col", {
                                           'error': isParamsErrorMap['allowanceNumber']
                                        })}
                                    >
                                        <h5 className="title">
                                            折讓單號碼
                                            {isParamsErrorMap['allowanceNumber'] ? <span className="error-tip">請輸入折讓單號碼</span> : null}
                                        </h5>
                                        <input
                                            type="text"
                                            value={allowanceNumber}
                                            onChange={(event) => this.onInputChange('allowanceNumber', event)}
                                        />
                                    </label>
                                    <label className="block-form-col">
                                        <h5 className="title">折讓日期</h5>
                                        <DayPickerInput
                                            overlayComponent={this.renderCustomDayPickerOverlay}
                                            onDayChange={(selectedDay, modifiers) => this.onDaySelectChange(selectedDay, modifiers)}
                                            formatDate={formatDate}
                                            parseDate={parseDate}
                                            format="YYYY/MM/DD"
                                            value={allowanceDayValue}
                                            dayPickerProps={{
                                                selectedDays: allowanceDay,
                                            }}
                                            placeholder="折讓日期"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="block-form">
                                <h3 className="block-title">商品資訊</h3>
                                <div className="block-form-wrapper">
                                    {pdtlist.map((product, index) => {
                                        return (
                                            <div className="block-form-row" key={index}>
                                                <label className="block-form-col" style={{maxWidth: '60px'}}>
                                                    <h5 className="title">折讓</h5>
                                                    <div className="checkbox-item" onClick={() => this.toggleIsAllowance(index)}>
                                                        <div className={classNames("checkbox", {
                                                               'checked': product.isAllowance
                                                            })}
                                                        >
                                                            <i className="zmdi zmdi-check"></i>
                                                        </div>
                                                    </div>
                                                </label>
                                                <label className="block-form-col blue">
                                                    <h5 className="title">商品名稱</h5>
                                                    <p className="description">{product.pdtname}</p>
                                                    {!product.isAllowance ? <div className="disable-overlay"></div> : null}
                                                </label>
                                                <label className="block-form-col blue">
                                                    <h5 className="title">商品編號</h5>
                                                    <p className="description">{product.pdtid}</p>
                                                    {!product.isAllowance ? <div className="disable-overlay"></div> : null}
                                                </label>
                                                <label className="block-form-col">
                                                    <h5 className="title">折讓數量</h5>
                                                    <input
                                                        type="number"
                                                        min={1}
                                                        max={invoicePdtlist[index].pdtcount}
                                                        value={product.pdtcount}
                                                        onChange={(event) => this.onPdtCountInputChange(index, event)}
                                                    />
                                                    {!product.isAllowance ? <div className="disable-overlay"></div> : null}
                                                </label>
                                                <label
                                                    className={classNames("block-form-col", {
                                                       'error': product.isParamsErrorMap['pdtprice']
                                                    })}
                                                >
                                                    <h5 className="title">
                                                        商品單價(未稅)
                                                        {product.isParamsErrorMap['pdtprice'] ? <span className="error-tip">商品單價需大於0</span> : null}
                                                    </h5>
                                                    <input
                                                        type="number"
                                                        min={0}
                                                        max={invoicePdtlist[index].pdtprice}
                                                        value={product.pdtprice}
                                                        onChange={(event) => this.onPdtPriceInputChange(index, event)}
                                                    />
                                                    {!product.isAllowance ? <div className="disable-overlay"></div> : null}
                                                </label>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    null
                }
            </div>
        );
    }

}
const mapStateToProps = function (state) {
    return {invoices: state.invoice.invoices};
};

const mapActionToProps = function (dispatch) {
    return {
        invoiceActions: bindActionCreators(actionCreators.invoiceActionCreators, dispatch),
        allowanceActions: bindActionCreators(actionCreators.allowanceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {withRef: true})(CreateAllowanceView);


// WEBPACK FOOTER //
// ./src/components/allowance/CreateAllowanceView.js